import { render, staticRenderFns } from "./ProductionChart.vue?vue&type=template&id=4cbe78f8&scoped=true&"
import script from "./ProductionChart.vue?vue&type=script&lang=js&"
export * from "./ProductionChart.vue?vue&type=script&lang=js&"
import style0 from "./ProductionChart.vue?vue&type=style&index=0&id=4cbe78f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbe78f8",
  null
  
)

export default component.exports